import { preventSkip } from '../../../helpers';

export function nextButtonClickCallBack(e) {
	e.stopPropagation();
	preventSkip(e);
}
